import { DEFAULT_DRUG_PANEL } from "./lib/constants";

const initialState = {
    selectedPanel: 0,
    isDirty: false,
    panels: [],
};

function newFootnoteSection() {
    return {
        items: [],
    };
}

function createPanel() {
    return {
        ...DEFAULT_DRUG_PANEL(),
        footnotes: newFootnoteSection(),
    };
}

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD_ITEM":
            const withNewFact = state.panels.map((p, i) => {
                if (i === state.selectedPanel) {
                    const stamp = Math.round(new Date().getTime() / 1000);
                    p[action.key].push({ ...action.value, key: `${action.key}_${stamp}` });
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: withNewFact,
            };
        case "ADD_PANEL":
            const addedPanels = [...state.panels];
            const newPanel = createPanel();

            addedPanels.push(newPanel);

            return {
                ...state,
                isDirty: true,
                panels: addedPanels,
                selectedPanel: addedPanels.length - 1,
            };
        case "REMOVE_ITEM":
            const withRemovedItem = state.panels.map((p, index) => {
                if (index === state.selectedPanel) {
                    const newItems = p[action.section].filter((i) => i.key !== action.key);
                    p[action.section] = newItems;
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: withRemovedItem,
            };
        case "REMOVE_PANEL":
            const removedPanels = [...state.panels];
            removedPanels.splice(state.selectedPanel, 1);

            return {
                ...state,
                isDirty: true,
                panels: removedPanels,
                selectedPanel: removedPanels.length - 1,
            };
        case "UPDATE_ITEM":
            const withUpdatedItem = state.panels.map((p, i) => {
                if (i === state.selectedPanel) {
                    const updatedItem = p[action.section].map((item) => {
                        if (item.key === action.value.key) {
                            return { ...action.value };
                        }

                        return { ...item };
                    });
                    p[action.section] = updatedItem;
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: withUpdatedItem,
            };
        case "UPDATE_STATE":
            const updatedPanels = state.panels.map((p, i) => {
                if (i === state.selectedPanel) {
                    if (p[action.key] && p[action.key].items) {
                        p[action.key].items = action.value;
                    } else {
                        p[action.key] = action.value;
                    }
                }

                return p;
            });

            return {
                ...state,
                isDirty: true,
                panels: updatedPanels,
            };
        case "SAVE_PANELS":
            return {
                ...state,
                isDirty: action.isDirty,
                panels: action.panels,
            };
        case "SET_DIRTY_FLAG":
            return {
                ...state,
                isDirty: action.isDirty,
            };
        case "SET_PANEL_INDEX":
            return {
                ...state,
                selectedPanel: action.selectedPanel,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
